import { render, staticRenderFns } from "./ListDataColumn.vue?vue&type=template&id=7f2669f4&"
import script from "./ListDataColumn.vue?vue&type=script&lang=js&"
export * from "./ListDataColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports